window.custom = window.custom || {};

window.custom.initializeSwiper = function (options) {
  // Default options
  const defaults = {
    sectionId: "",
    colsDesktop: 4,
    colsMobile: 2,
    spaceBetween: 16,
    loop: true,
    autoplay: false,
    delay: 3000,
    speed: 300,
  };

  // Merge provided options with defaults
  const settings = { ...defaults, ...options };

  // Validate required parameters
  if (!settings.sectionId) {
    console.error("Swiper initialization failed: sectionId is required");
    return null;
  }

  const swiperContainer = `.fp-swiper-${settings.sectionId}`;
  const nextButton = `.fp-swiper-button-next-${settings.sectionId}`;
  const prevButton = `.fp-swiper-button-prev-${settings.sectionId}`;
  const scrollbar = `.fp-swiper-scrollbar-${settings.sectionId}`;

  const container = document.querySelector(swiperContainer);
  if (!container) {
    console.warn(`Swiper container ${swiperContainer} not found.`);
    return null;
  }

  // Check if there are enough slides
  const slides = container.querySelectorAll(".swiper-slide");
  if (slides.length <= 1) {
    console.warn(
      `Not enough slides in ${swiperContainer}. Swiper not initialized.`
    );
    return null;
  }

  // Swiper configuration
  const swiperConfig = {
    slidesPerView: 2,
    spaceBetween: settings.spaceBetween,
    loop: settings.loop,
    speed: settings.speed,
    breakpoints: {
      320: { slidesPerView: 2 },
      640: { slidesPerView: Math.min(settings.colsMobile, slides.length) },
      800: { slidesPerView: Math.min(settings.colsDesktop - 1, slides.length) },
      992: { slidesPerView: Math.min(settings.colsDesktop, slides.length) },
      1399: {
        slidesPerView: Math.min(settings.colsDesktop, slides.length),
        spaceBetween: settings.spaceBetween,
      },
    },
    navigation: {
      nextEl: nextButton,
      prevEl: prevButton,
    },
    scrollbar: {
      el: scrollbar,
      draggable: true,
    },
  };

  // Add autoplay if enabled
  if (settings.autoplay) {
    swiperConfig.autoplay = {
      delay: settings.delay,
      disableOnInteraction: false,
    };
  }

  // Initialize Swiper
  try {
    let swiperRelated;

    swiperRelated = new Swiper(swiperContainer, swiperConfig);
    return swiperRelated;
  } catch (error) {
    console.error(
      `Error initializing Swiper for section ${settings.sectionId}:`,
      error
    );
    return null;
  }
};

window.custom.initializeGlobalSwiper = function (selector, options) {
  if (!selector || typeof selector !== "string") {
    console.error("Invalid selector provided to initializeGlobalSwiper");
    return null;
  }

  const defaultOptions = {
    slidesPerView: 1,
    spaceBetween: 10,
    breakpoints: {},
  };

  const mergedOptions = Object.assign({}, defaultOptions, options);

  try {
    const swiperElement = document.querySelector(selector);
    if (!swiperElement) {
      console.warn(`No element found with selector: ${selector}`);
      return null;
    }

    return new Swiper(selector, mergedOptions);
  } catch (error) {
    console.error("Error initializing Swiper:", error);
    return null;
  }
};

// Assign the BackToTop object to window.custom
window.custom.BackToTop = {
  button: null,
  scrollThreshold: 20,

  init() {
    this.button = document.getElementById("backToTopBtn");
    if (!this.button) {
      return;
    }

    window.addEventListener("scroll", this.handleScroll.bind(this));
    this.button.addEventListener("click", this.scrollToTop.bind(this));
  },

  handleScroll() {
    if (!this.button) return;

    if (
      document.body.scrollTop > this.scrollThreshold ||
      document.documentElement.scrollTop > this.scrollThreshold
    ) {
      this.showButton();
    } else {
      this.hideButton();
    }
  },

  showButton() {
    this.button.style.display = "block";
  },

  hideButton() {
    this.button.style.display = "none";
  },

  scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  },
};

// Add alt tag and height and width if not availabel for seo
const ImageManager = {
  // Properties to store images and configuration
  images: [],
  config: {
    defaultAlt: "Image",
    defaultHeight: "",
    defaultWidth: "",
  },

  // Method to initialize the object
  init() {
    this.images = document.querySelectorAll("img");
    this.setupEventListeners();
    this.processImages();
  },

  // Set up event listeners
  setupEventListeners() {
    window.addEventListener("load", this.processImages.bind(this));
    // window.addEventListener('resize', this.updateImageDimensions.bind(this));
  },

  // Process all images
  processImages() {
    if (this.images.length === 0) {
      console.warn("No images found on the page.");
      return;
    }

    this.images.forEach((img) => {
      this.setAltText(img);
      this.setDimensions(img);
    });
  },

  // Set alt text if not present
  setAltText(img) {
    if (!img.getAttribute("alt")) {
      const src = img.getAttribute("src");
      img.setAttribute(
        "alt",
        src ? src.split("/").pop() : this.config.defaultAlt
      );
    }
  },

  // Set dimensions if not present
  setDimensions(img) {
    if (!img.hasAttribute("height")) {
      img.setAttribute("height", this.config.defaultHeight);
    }
    if (!img.hasAttribute("width")) {
      img.setAttribute("width", this.config.defaultWidth);
    }
  },

  // Update image dimensions on window resize
  updateImageDimensions() {
    this.images.forEach((img) => {
      const aspectRatio = img.naturalWidth / img.naturalHeight;
      const newWidth = img.offsetWidth;
      img.style.height = `${newWidth / aspectRatio}px`;
    });
  },
};

class SmoothScroll {
  constructor() {
    this.buttonClass = ".button_slide_to_top";
    this.targetClass = ".pre-approval-form-section";
    this.offset = 100; // Extra scroll distance past the target
    this.duration = 800; // Animation duration in ms
    this.debounceDelay = 100; // Debounce delay for click events
    this.init();
  }

  // Initialize event listeners
  init() {
    this.buttons = document.querySelectorAll(this.buttonClass);
    this.target = document.querySelector(this.targetClass);
    this.bindEvents();
  }

  // Bind click events with debouncing
  bindEvents() {
    if (!this.buttons.length || !this.target) return;

    this.buttons.forEach((button) => {
      button.addEventListener(
        "click",
        this.debounce((e) => {
          e.preventDefault();
          e.stopPropagation();
          this.scrollToTarget();
        }, this.debounceDelay)
      );
    });
  }

  // Debounce utility to prevent rapid clicks
  debounce(func, wait) {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  }

  // Smooth scroll to target with easing
  scrollToTarget() {
    if (!this.target) return;

    const targetPosition =
      this.target.getBoundingClientRect().top + window.pageYOffset;
    const finalPosition = targetPosition - this.offset;
    const startPosition = window.pageYOffset;
    const distance = finalPosition - startPosition;
    let startTime = null;

    // Easing function (easeInOutQuad)
    const ease = (t, b, c, d) => {
      t /= d / 2;
      if (t < 1) return (c / 2) * t * t + b;
      t--;
      return (-c / 2) * (t * (t - 2) - 1) + b;
    };

    // Animation loop
    const animateScroll = (timestamp) => {
      if (!startTime) startTime = timestamp;
      const progress = timestamp - startTime;
      const percentage = Math.min(progress / this.duration, 1);
      window.scrollTo(0, ease(percentage, startPosition, distance, 1));

      if (progress < this.duration) {
        requestAnimationFrame(animateScroll);
      } else {
        // Ensure focus for accessibility
        this.target.setAttribute("tabindex", "-1");
        this.target.focus({ preventScroll: true });
        this.target.removeAttribute("tabindex");
      }
    };

    requestAnimationFrame(animateScroll);
  }

  // Cleanup method for removing event listeners
  destroy() {
    this.buttons.forEach((button) => {
      button.removeEventListener("click", this.scrollToTarget);
    });
  }
}

// Initialize the ImageManager
ImageManager.init();

// Initialize the BackToTop object
window.custom.BackToTop.init();

// Instantiate the class
const smoothScroll = new SmoothScroll();